module.exports = __webpack_public_path__ + "static/css3-c3805b5eef5f9ee4d854aa0b738a5700.png";